// --- No changes here: imports, state, handlers ---
import React, { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import {
  Paper,
  Typography,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Button,
  Card,
  CardContent,
  Box,
  Checkbox,
  ListItemText,
  OutlinedInput,
    Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material';

const IntraOp = ({ onSubmit = () => { } }) => {
  const [date, setDate] = useState(''); // Placeholder for date state
    const [loading, setLoading] = useState(false);
    const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
    const [openPasswordModal, setOpenPasswordModal] = useState(false);
    const [password, setPassword] = useState('');
    const [downloadFormat, setDownloadFormat] = useState('excel');
  const [formData, setFormData] = useState({
    scheme: '',
    ciCompany: '',
    sideOfImplant: '',
    modelOfImplant: '',
    speechProcessorModel: '',
    surgeryDate: '',
    surgeonName: '',
    surgeryCenter: '',
    surgeryType: '',
    audiologistName: '',
    intraOpTest: {
      boxTestRight: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
      boxTestLeft: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
      impedanceRight: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
      impedanceLeft: { status: '', noOfElectrodes: '', specifyElectrodes: '' },
    },
    thresholdRight: [],
    thresholdLeft: [],
    impedanceDocument: null,
    thresholdDocument: null,
  });

  const [searchOpNumber, setSearchOpNumber] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);

const [error, setError] = useState('');
  const thresholdOptions = ['Advanced NRT', 'ART', 'ESRT', 'EABR', 'ECAP'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleThresholdChange = (side) => (event) => {
    const {
      target: { value },
    } = event;
    const fieldName = side === 'right' ? 'thresholdRight' : 'thresholdLeft';
    setFormData((prev) => ({
      ...prev,
      [fieldName]: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  const handleTestChange = (testType, subField, value) => {
    setFormData((prev) => ({
      ...prev,
      intraOpTest: {
        ...prev.intraOpTest,
        [testType]: {
          ...prev.intraOpTest[testType],
          [subField]: value,
        },
      },
    }));
  };
  const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Intraoperative CI ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "intraoperative_ci",
          formName: "Intraoperative_CI",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Intraoperative_CI_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };
  const handleFileChange = (field, file) => {
    setFormData((prev) => ({ ...prev, [field]: file }));
  };

const handleSearch = async () => {
  if (!searchOpNumber.trim()) {
    setError('Please enter an OP number');
    return;
  }

  setLoading(true);
  setError('');
  
  try {
    // Use the same patient search endpoint as your Intraoperative component
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/intraoperative/search/${searchOpNumber.trim()}`);
    
    if (response.ok) {
      const patientData = await response.json();
      setSearchResult(patientData);
      setIsFormVisible(true);
      
      // Pre-fill the form with existing OUTCOME data if available
      try {
        const existingDataResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/outcome/${searchOpNumber.trim()}`);
        if (existingDataResponse.ok) {
          const existingData = await existingDataResponse.json();
          console.log('Existing outcome data found:', existingData);
          
          // Helper function to map database fields to form data
          const mapOutcomeData = (dbData) => {
            return {
              audiogramRows: [
                {
                  device: dbData.audiogram_device_1 || '',
                  ear: dbData.audiogram_ear_1 || '',
                  condition: dbData.audiogram_condition_1 || '',
                  frequencies: {
                    hz250: dbData.audiogram_hz250_1 || '',
                    hz500: dbData.audiogram_hz500_1 || '',
                    hz1k: dbData.audiogram_hz1k_1 || '',
                    hz1_5k: dbData.audiogram_hz1_5k_1 || '',
                    hz2k: dbData.audiogram_hz2k_1 || '',
                    hz3k: dbData.audiogram_hz3k_1 || '',
                    hz4k: dbData.audiogram_hz4k_1 || '',
                    hz6k: dbData.audiogram_hz6k_1 || '',
                    hz8k: dbData.audiogram_hz8k_1 || ''
                  }
                },
                {
                  device: dbData.audiogram_device_2 || '',
                  ear: dbData.audiogram_ear_2 || '',
                  condition: dbData.audiogram_condition_2 || '',
                  frequencies: {
                    hz250: dbData.audiogram_hz250_2 || '',
                    hz500: dbData.audiogram_hz500_2 || '',
                    hz1k: dbData.audiogram_hz1k_2 || '',
                    hz1_5k: dbData.audiogram_hz1_5k_2 || '',
                    hz2k: dbData.audiogram_hz2k_2 || '',
                    hz3k: dbData.audiogram_hz3k_2 || '',
                    hz4k: dbData.audiogram_hz4k_2 || '',
                    hz6k: dbData.audiogram_hz6k_2 || '',
                    hz8k: dbData.audiogram_hz8k_2 || ''
                  }
                },
                {
                  device: dbData.audiogram_device_3 || '',
                  ear: dbData.audiogram_ear_3 || '',
                  condition: dbData.audiogram_condition_3 || '',
                  frequencies: {
                    hz250: dbData.audiogram_hz250_3 || '',
                    hz500: dbData.audiogram_hz500_3 || '',
                    hz1k: dbData.audiogram_hz1k_3 || '',
                    hz1_5k: dbData.audiogram_hz1_5k_3 || '',
                    hz2k: dbData.audiogram_hz2k_3 || '',
                    hz3k: dbData.audiogram_hz3k_3 || '',
                    hz4k: dbData.audiogram_hz4k_3 || '',
                    hz6k: dbData.audiogram_hz6k_3 || '',
                    hz8k: dbData.audiogram_hz8k_3 || ''
                  }
                },
                {
                  device: dbData.audiogram_device_4 || '',
                  ear: dbData.audiogram_ear_4 || '',
                  condition: dbData.audiogram_condition_4 || '',
                  frequencies: {
                    hz250: dbData.audiogram_hz250_4 || '',
                    hz500: dbData.audiogram_hz500_4 || '',
                    hz1k: dbData.audiogram_hz1k_4 || '',
                    hz1_5k: dbData.audiogram_hz1_5k_4 || '',
                    hz2k: dbData.audiogram_hz2k_4 || '',
                    hz3k: dbData.audiogram_hz3k_4 || '',
                    hz4k: dbData.audiogram_hz4k_4 || '',
                    hz6k: dbData.audiogram_hz6k_4 || '',
                    hz8k: dbData.audiogram_hz8k_4 || ''
                  }
                }
              ],
              lingSoundAwareness: {
                right: {
                  device: dbData.ling_awareness_right_device || '',
                  condition: dbData.ling_awareness_right_condition || '',
                  a: dbData.ling_awareness_right_a || '',
                  i: dbData.ling_awareness_right_i || '',
                  u: dbData.ling_awareness_right_u || '',
                  m: dbData.ling_awareness_right_m || '',
                  s: dbData.ling_awareness_right_s || '',
                  sh: dbData.ling_awareness_right_sh || ''
                },
                left: {
                  device: dbData.ling_awareness_left_device || '',
                  condition: dbData.ling_awareness_left_condition || '',
                  a: dbData.ling_awareness_left_a || '',
                  i: dbData.ling_awareness_left_i || '',
                  u: dbData.ling_awareness_left_u || '',
                  m: dbData.ling_awareness_left_m || '',
                  s: dbData.ling_awareness_left_s || '',
                  sh: dbData.ling_awareness_left_sh || ''
                }
              },
              lingSoundIdentification: {
                right: {
                  device: dbData.ling_identification_right_device || '',
                  condition: dbData.ling_identification_right_condition || '',
                  a: dbData.ling_identification_right_a || '',
                  i: dbData.ling_identification_right_i || '',
                  u: dbData.ling_identification_right_u || '',
                  m: dbData.ling_identification_right_m || '',
                  s: dbData.ling_identification_right_s || '',
                  sh: dbData.ling_identification_right_sh || ''
                },
                left: {
                  device: dbData.ling_identification_left_device || '',
                  condition: dbData.ling_identification_left_condition || '',
                  a: dbData.ling_identification_left_a || '',
                  i: dbData.ling_identification_left_i || '',
                  u: dbData.ling_identification_left_u || '',
                  m: dbData.ling_identification_left_m || '',
                  s: dbData.ling_identification_left_s || '',
                  sh: dbData.ling_identification_left_sh || ''
                }
              },
              speechIdentification: {
                right: {
                  device: dbData.speech_identification_right_device || '',
                  condition: dbData.speech_identification_right_condition || '',
                  open: dbData.speech_identification_right_open || '',
                  closed: dbData.speech_identification_right_closed || ''
                },
                left: {
                  device: dbData.speech_identification_left_device || '',
                  condition: dbData.speech_identification_left_condition || '',
                  open: dbData.speech_identification_left_open || '',
                  closed: dbData.speech_identification_left_closed || ''
                }
              },
              espRows: [
                {
                  device: dbData.esp_device_1 || '',
                  ear: dbData.esp_ear_1 || '',
                  test: dbData.esp_test_1 || '',
                  AV: dbData.esp_av_1 || '',
                  A1: dbData.esp_a1_1 || '',
                  A2: dbData.esp_a2_1 || ''
                },
                {
                  device: dbData.esp_device_2 || '',
                  ear: dbData.esp_ear_2 || '',
                  test: dbData.esp_test_2 || '',
                  AV: dbData.esp_av_2 || '',
                  A1: dbData.esp_a1_2 || '',
                  A2: dbData.esp_a2_2 || ''
                },
                {
                  device: dbData.esp_device_3 || '',
                  ear: dbData.esp_ear_3 || '',
                  test: dbData.esp_test_3 || '',
                  AV: dbData.esp_av_3 || '',
                  A1: dbData.esp_a1_3 || '',
                  A2: dbData.esp_a2_3 || ''
                },
                {
                  device: dbData.esp_device_4 || '',
                  ear: dbData.esp_ear_4 || '',
                  test: dbData.esp_test_4 || '',
                  AV: dbData.esp_av_4 || '',
                  A1: dbData.esp_a1_4 || '',
                  A2: dbData.esp_a2_4 || ''
                },
                {
                  device: dbData.esp_device_5 || '',
                  ear: dbData.esp_ear_5 || '',
                  test: dbData.esp_test_5 || '',
                  AV: dbData.esp_av_5 || '',
                  A1: dbData.esp_a1_5 || '',
                  A2: dbData.esp_a2_5 || ''
                },
                {
                  device: dbData.esp_device_6 || '',
                  ear: dbData.esp_ear_6 || '',
                  test: dbData.esp_test_6 || '',
                  AV: dbData.esp_av_6 || '',
                  A1: dbData.esp_a1_6 || '',
                  A2: dbData.esp_a2_6 || ''
                }
              ],
              mais: {
                score: dbData.mais_score || ''
              },
              questionnaires: {
                reels: {
                  rla: dbData.reels_rla || '',
                  ela: dbData.reels_ela || ''
                },
                secs: {
                  crla: dbData.secs_crla || '',
                  cela: dbData.secs_cela || ''
                },
                integratedScaleOfDevelopment: {
                  rl: dbData.isd_rl || '',
                  el: dbData.isd_el || '',
                  fineMotor: dbData.isd_fine_motor || '',
                  grossMotor: dbData.isd_gross_motor || '',
                  adl: dbData.isd_adl || '',
                  cognitiveSkills: dbData.isd_cognitive_skills || '',
                  socialSkills: dbData.isd_social_skills || '',
                  emotionalSkills: dbData.isd_emotional_skills || ''
                }
              }
            };
          };

          const mappedData = mapOutcomeData(existingData);
          setFormData(mappedData);
          setDate(existingData.date_of_assessment || '');
        }
      } catch (error) {
        console.log('No existing outcome data found, starting with fresh form');
      }
    } else {
      const errorData = await response.json();
      setError(errorData.error || 'Patient not found. Please check the OP number.');
      setSearchResult(null);
      setIsFormVisible(false);
    }
  } catch (error) {
    console.error('Error searching for patient:', error);
    setError('Error searching for patient. Please check your connection.');
    setSearchResult(null);
    setIsFormVisible(false);
  } finally {
    setLoading(false);
  }
};
 
// Updated handleSubmit function
const handleSubmit = async () => {
  if (!searchOpNumber.trim()) {
    alert('Please search for a patient first');
    return;
  }

  try {
    const formDataToSend = new FormData();
    
    // Add all form data
    formDataToSend.append('opNumber', searchOpNumber);
    formDataToSend.append('dateOfAssessment', date);
    formDataToSend.append('scheme', formData.scheme);
    formDataToSend.append('ciCompany', formData.ciCompany);
    formDataToSend.append('sideOfImplant', formData.sideOfImplant);
    formDataToSend.append('modelOfImplant', formData.modelOfImplant);
    formDataToSend.append('speechProcessorModel', formData.speechProcessorModel);
    formDataToSend.append('surgeryDate', formData.surgeryDate);
    formDataToSend.append('surgeonName', formData.surgeonName);
    formDataToSend.append('surgeryCenter', formData.surgeryCenter);
    formDataToSend.append('surgeryType', formData.surgeryType);
    formDataToSend.append('audiologistName', formData.audiologistName);
    formDataToSend.append('intraOpTest', JSON.stringify(formData.intraOpTest));
    formDataToSend.append('thresholdRight', JSON.stringify(formData.thresholdRight));
    formDataToSend.append('thresholdLeft', JSON.stringify(formData.thresholdLeft));

    // Add files if they exist
    if (formData.impedanceDocument) {
      formDataToSend.append('impedanceDocument', formData.impedanceDocument);
    }
    if (formData.thresholdDocument) {
      formDataToSend.append('thresholdDocument', formData.thresholdDocument);
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/intraoperative`, {
      method: 'POST',
      body: formDataToSend,
    });

    if (response.ok) {
      const result = await response.json();
      alert('Intraoperative data saved successfully!');
      console.log('Saved data:', result.data);
      
      // Optionally reset form
      // setFormData({ ...initial form state });
      // setDate('');
    } else {
      const error = await response.json();
      alert(`Error saving data: ${error.error}`);
    }
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form');
  }
};

  const renderThresholdField = (side, label) => (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small">
        <InputLabel>{label}</InputLabel>
        <Select
          multiple
          value={formData[side === 'right' ? 'thresholdRight' : 'thresholdLeft']}
          onChange={handleThresholdChange(side)}
          input={<OutlinedInput label={label} />}
          renderValue={(selected) => selected.join(', ')}
        >
          {thresholdOptions.map((option) => (
            <MenuItem key={option} value={option}>
              <Checkbox checked={formData[side === 'right' ? 'thresholdRight' : 'thresholdLeft'].indexOf(option) > -1} />
              <ListItemText primary={option} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );

  const renderTestFields = (side, type, label) => (
    <>
      <Grid item xs={12}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500, mt: 2 }}>
          {label} ({side})
        </Typography> 
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth size="small">
          <InputLabel shrink={true}>Status</InputLabel>
          <Select
            label="Status"
            value={formData.intraOpTest[type].status}
            onChange={(e) => handleTestChange(type, 'status', e.target.value)}
            displayEmpty
            renderValue={value => value || "Select Status"}
          >
            <MenuItem value="">Select</MenuItem>
            {type.includes('boxTest') ? [
              <MenuItem key="normal" value="Normal">Normal</MenuItem>,
              <MenuItem key="defective" value="Defective">Defective</MenuItem>,
            ] : [
              <MenuItem key="normal" value="Normal">Normal</MenuItem>,
              <MenuItem key="open" value="Open">Open</MenuItem>,
              <MenuItem key="short" value="Short">Short</MenuItem>,
            ]}
          </Select>
        </FormControl>
      </Grid>
      {formData.intraOpTest[type].status && (
        <>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              size="small"
              label="No of Electrodes"
              value={formData.intraOpTest[type].noOfElectrodes}
              onChange={(e) => handleTestChange(type, 'noOfElectrodes', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              size="small"
              label="Specify Electrodes"
              value={formData.intraOpTest[type].specifyElectrodes}
              onChange={(e) => handleTestChange(type, 'specifyElectrodes', e.target.value)}
            />
          </Grid>
        </>
      )}
    </>
  );

  const renderBothEarsTestFields = () => (
    <>
      {/* Right Ear - All in one row */}
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, color: 'primary.main' }}>
          Right Ear
        </Typography>
      </Grid>
      
      {/* Box Test Right */}
      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          Box Test (Right)
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth size="small">
              <InputLabel shrink={true}>Status</InputLabel>
              <Select
                label="Status"
                value={formData.intraOpTest.boxTestRight.status}
                onChange={(e) => handleTestChange('boxTestRight', 'status', e.target.value)}
                displayEmpty
                renderValue={value => value || "Select Status"}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Normal">Normal</MenuItem>
                <MenuItem value="Defective">Defective</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {formData.intraOpTest.boxTestRight.status && (
            <>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="No of Electrodes"
                  value={formData.intraOpTest.boxTestRight.noOfElectrodes}
                  onChange={(e) => handleTestChange('boxTestRight', 'noOfElectrodes', e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Specify Electrodes"
                  value={formData.intraOpTest.boxTestRight.specifyElectrodes}
                  onChange={(e) => handleTestChange('boxTestRight', 'specifyElectrodes', e.target.value)}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>

      {/* Impedance Right */}
      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          Impedance (Right)
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth size="small">
              <InputLabel shrink={true}>Status</InputLabel>
              <Select
                label="Status"
                value={formData.intraOpTest.impedanceRight.status}
                onChange={(e) => handleTestChange('impedanceRight', 'status', e.target.value)}
                displayEmpty
                renderValue={value => value || "Select Status"}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Normal">Normal</MenuItem>
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="Short">Short</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {formData.intraOpTest.impedanceRight.status && (
            <>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="No of Electrodes"
                  value={formData.intraOpTest.impedanceRight.noOfElectrodes}
                  onChange={(e) => handleTestChange('impedanceRight', 'noOfElectrodes', e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Specify Electrodes"
                  value={formData.intraOpTest.impedanceRight.specifyElectrodes}
                  onChange={(e) => handleTestChange('impedanceRight', 'specifyElectrodes', e.target.value)}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>

      {/* Threshold for Right Ear */}
      <Grid item xs={12} sm={6}>
        {renderThresholdField('right', 'Threshold (Right)')}
      </Grid>

      {/* Left Ear - All in one row */}
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, color: 'primary.main' }}>
          Left Ear
        </Typography>
      </Grid>
      
      {/* Box Test Left */}
      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          Box Test (Left)
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth size="small">
              <InputLabel shrink={true}>Status</InputLabel>
              <Select
                label="Status"
                value={formData.intraOpTest.boxTestLeft.status}
                onChange={(e) => handleTestChange('boxTestLeft', 'status', e.target.value)}
                displayEmpty
                renderValue={value => value || "Select Status"}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Normal">Normal</MenuItem>
                <MenuItem value="Defective">Defective</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {formData.intraOpTest.boxTestLeft.status && (
            <>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="No of Electrodes"
                  value={formData.intraOpTest.boxTestLeft.noOfElectrodes}
                  onChange={(e) => handleTestChange('boxTestLeft', 'noOfElectrodes', e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Specify Electrodes"
                  value={formData.intraOpTest.boxTestLeft.specifyElectrodes}
                  onChange={(e) => handleTestChange('boxTestLeft', 'specifyElectrodes', e.target.value)}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>

      {/* Impedance Left */}
      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          Impedance (Left)
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth size="small">
              <InputLabel shrink={true}>Status</InputLabel>
              <Select
                label="Status"
                value={formData.intraOpTest.impedanceLeft.status}
                onChange={(e) => handleTestChange('impedanceLeft', 'status', e.target.value)}
                displayEmpty
                renderValue={value => value || "Select Status"}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Normal">Normal</MenuItem>
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="Short">Short</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {formData.intraOpTest.impedanceLeft.status && (
            <>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="No of Electrodes"
                  value={formData.intraOpTest.impedanceLeft.noOfElectrodes}
                  onChange={(e) => handleTestChange('impedanceLeft', 'noOfElectrodes', e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Specify Electrodes"
                  value={formData.intraOpTest.impedanceLeft.specifyElectrodes}
                  onChange={(e) => handleTestChange('impedanceLeft', 'specifyElectrodes', e.target.value)}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>

      {/* Threshold for Left Ear */}
      <Grid item xs={12} sm={6}>
        {renderThresholdField('left', 'Threshold (Left)')}
      </Grid>
    </>
  );

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 1400, mx: 'auto', mt: 4, mb: 6 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
        Intraoperative Cochlear Implant Details
      </Typography>

      {/* Search Section */}
      <Card elevation={2} sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
            Search Patient
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Search OP Number"
                value={searchOpNumber}
                onChange={(e) => setSearchOpNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button variant="contained" onClick={handleSearch} sx={{ mt: 1 }}>
                Search
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {searchResult && (
        <Card elevation={3} sx={{ mt: 4, p: 2, borderRadius: 3, backgroundColor: '#f9f9f9' }}>
          <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Demographic Information
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>Name:</strong> {searchResult.name}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>Age:</strong> {searchResult.age}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>IP Number:</strong> {searchResult.ip_number}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>OP Number:</strong> {searchResult.op_number || 'N/A'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>Phone:</strong> {searchResult.phone}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>Address:</strong> {searchResult.address || 'N/A'}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography><strong>Medical History:</strong> {searchResult.history || 'N/A'}</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}

      {isFormVisible && (
        <>
          {/* Date Section */}
          <Card elevation={2} sx={{ mt: 4 }}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    name="dateOfAssessment"
                    label="Date of Assessment"
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
      <Box sx={{ position: 'absolute', top: 350, right: 140 }}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<DownloadIcon />}
          onClick={handleDownloadClick}
          disabled={loading}
          sx={{ 
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
              transition: 'all 0.3s ease'
            }
          }}
        >
          Download 
        </Button>
      </Box>
          {/* Intra-Operative Form */}
          <Card elevation={2} sx={{ mt: 4 }}>
            <CardContent>
              <Typography variant="h5" fontWeight="bold" color="secondary" gutterBottom>
                Intra-Operative Form
              </Typography>
              <Divider sx={{ mb: 3 }} />

              <Grid container spacing={3}>
                {/* First Row */}
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel shrink={true}>Scheme</InputLabel>
                    <Select
                      label="Scheme"
                      name="scheme"
                      value={formData.scheme}
                      onChange={handleChange}
                      displayEmpty
                      renderValue={value => value || "Select Scheme"}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {['ADIP', 'SAST', 'ESI', 'Self', 'Other'].map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel shrink={true}>CI Company</InputLabel>
                    <Select
                      label="CI Company"
                      name="ciCompany"
                      value={formData.ciCompany}
                      onChange={handleChange}
                      displayEmpty
                      renderValue={value => value || "Select CI Company"}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {['Cochlear', 'Med-El', 'Advanced Bionic', 'Digisonic', 'AB'].map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Second Row */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Model of Implant"
                    name="modelOfImplant"
                    value={formData.modelOfImplant}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Speech Processor Model"
                    name="speechProcessorModel"
                    value={formData.speechProcessorModel}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    type="date"
                    label="Surgery Date"
                    name="surgeryDate"
                    value={formData.surgeryDate}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Third Row */}
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Surgeon Name"
                    name="surgeonName"
                    value={formData.surgeonName}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Surgery Center"
                    name="surgeryCenter"
                    value={formData.surgeryCenter}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Audiologist Name"
                    name="audiologistName"
                    value={formData.audiologistName}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Fourth Row */}
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel shrink={true}>Surgery Type</InputLabel>
                    <Select
                      label="Surgery Type"
                      name="surgeryType"
                      value={formData.surgeryType}
                      onChange={handleChange}
                      displayEmpty
                      renderValue={value => value || "Select Surgery Type"}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {[
                        'Mastoidectomy posterior tympanotomy',
                        'Veria/transcranial approach',
                        'Suprameatal approach',
                        'Minimal incision approach',
                      ].map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Intra Op Test Findings */}
          <Card elevation={2} sx={{ mt: 4 }}>
            <CardContent>
              <Typography variant="h6" fontWeight="medium" gutterBottom>
                Intra-Op Test Findings
              </Typography>
              <Divider sx={{ mb: 3 }} />
              
              {/* Side of Implant Dropdown in Intra-Op Test Findings */}
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel shrink={true}>Side of Implant</InputLabel>
                    <Select
                      label="Side of Implant"
                      name="sideOfImplant"
                      value={formData.sideOfImplant}
                      onChange={handleChange}
                      displayEmpty
                      renderValue={value => value || "Select Side"}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {['Right', 'Left', 'Both'].map((opt) => (
                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              
              <Grid container spacing={3} sx={{ mt: 1 }}>
                {formData.sideOfImplant === 'Right' && (
                  <>
                    {renderTestFields('Right', 'boxTestRight', 'Box Test')}
                    {renderTestFields('Right', 'impedanceRight', 'Impedance')}
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 500, mt: 2 }}>
                        Threshold (Right)
                      </Typography>
                    </Grid>
                    {renderThresholdField('right', 'Select Threshold')}
                  </>
                )}
                
                {formData.sideOfImplant === 'Left' && (
                  <>
                    {renderTestFields('Left', 'boxTestLeft', 'Box Test')}
                    {renderTestFields('Left', 'impedanceLeft', 'Impedance')}
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 500, mt: 2 }}>
                        Threshold (Left)
                      </Typography>
                    </Grid>
                    {renderThresholdField('left', 'Select Threshold')}
                  </>
                )}
                
                {formData.sideOfImplant === 'Both' && renderBothEarsTestFields()}
              </Grid>
            </CardContent>
          </Card>

          {/* Documents Section */}
          <Card elevation={2} sx={{ mt: 4 }}>
            <CardContent>
              <Typography variant="h6" fontWeight="medium" gutterBottom>
                Documents to Upload
              </Typography>
              <Divider sx={{ mb: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      type="file"
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      label="Impedance Document"
                      onChange={(e) => handleFileChange('impedanceDocument', e.target.files[0])}
                    />
                    <Typography variant="caption" sx={{ mt: 0.5, display: 'block', color: 'text.secondary' }}>
                      {formData.impedanceDocument ? formData.impedanceDocument.name : 'No file chosen'}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      type="file"
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      label="Threshold Document"
                      onChange={(e) => handleFileChange('thresholdDocument', e.target.files[0])}
                    />
                    <Typography variant="caption" sx={{ mt: 0.5, display: 'block', color: 'text.secondary' }}>
                      {formData.thresholdDocument ? formData.thresholdDocument.name : 'No file chosen'}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
    {/* Password Modal */}
      <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
          {/* Submit Button */}
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{ px: 5, py: 1.25, borderRadius: 2 }}
              >
                Submit
              </Button>
            </Box>
          </Grid>
        </>
      )}
    </Paper>
  ); 
};

export default IntraOp;